type Entries<TObject> = {
  [TKey in keyof TObject]: [TKey, TObject[TKey]];
}[keyof TObject][];

/**
 * Get typed entries from an object, use instead of Object.entries.
 *
 * @param data Object to get typed entries from
 * @returns Returns typed entries from object
 */
export function entriesFromObject<TObject extends object>(data: TObject): Entries<TObject> {
  return (Object.entries(data) as Entries<typeof data>).map(
    ([key, value]) => [key, value] as const
    // ^? (parameter) key: "a" | "b" | "c"
  );
}

type TypedEntries<TObject> = {
  [K in keyof TObject]-?: [K, TObject[K]];
}[keyof TObject][];

/**
 * Typecast object and return its entries from Object.entries.
 *
 * @param data Object to type
 * @returns Typed data entries
 */
export function typedObjectEntries<TObject extends object>(data: TObject): TypedEntries<typeof data> {
  return Object.entries(data) as TypedEntries<typeof data>;
}
